var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    height: 48,
    viewBox: "0 -960 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M413-102v-227l57-168q2-7 8-12t17-5h303q11 0 16.5 4.5T823-497l57 168v227q0 9.308-6.346 15.654T858-80h-22.256Q827-80 820.5-86.346T814-102v-45H479v45q0 9.308-6.346 15.654T457-80h-22.256Q426-80 419.5-86.346T413-102Zm53-257h361l-38-115H504l-38 115Zm-13 40v132-132Zm67 106q16.575 0 27.787-11.212Q559-235.425 559-252q0-16.575-11.213-27.788Q536.575-291 520-291t-27.788 11.212Q481-268.575 481-252q0 16.575 11.212 27.788Q503.425-213 520-213Zm253 0q16.575 0 27.787-11.212Q812-235.425 812-252q0-16.575-11.213-27.788Q789.575-291 773-291t-27.787 11.212Q734-268.575 734-252q0 16.575 11.213 27.788Q756.425-213 773-213ZM240-388v-73h73v73h-73Zm207-259v-73h73v73h-73ZM240-234v-73h73v73h-73Zm0 154v-73h73v73h-73ZM80-80v-541h207v-259h393v260h-60v-200H347v259H140v481H80Zm373-107h387v-132H453v132Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCity);
export default __webpack_public_path__ + "static/media/city.c2adffdfc6d10549b1251b5c8619252c.svg";
export { ForwardRef as ReactComponent };